<div class="filter-bar" fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field class="filter" appearance="outline" subscriptSizing="dynamic">
        <input
        #filter
        matInput
        type="text"
        (keyup)="applyFilter($event.target.value, filter)"
        [placeholder]="searchPlaceholder"
        />
        <mat-icon matSuffix svgIcon="magnify"></mat-icon>
    </mat-form-field>

    <mat-slide-toggle *ngIf="showToggle" color="primary" class="slide-toggle" [checked]="toggleValue" (change)="onToggleChange($event.checked)">
        {{ toggleLabel }}
    </mat-slide-toggle>

    <div fxFlex>
        <ng-content></ng-content>
    </div>
</div>
